import moment from 'moment';
import 'moment-timezone';

import Chart from 'chart.js';

angular.module('am4').directive('chart', function($http, $timeout, $translate, rgba, randomColorGenerator, $filter) {
    function transparentize(color) {
        return rgba(color, 0.2);
    }

    return {
        restrict: 'E',
        scope: {
            reportType: '=',
            timeZone: '=',
            data: '='
        },
        link: function(scope, element) {
            scope.data = angular.copy(scope.data);

            if (!scope.timeZone) {
                scope.timeZone = 'UTC';
            }

            var ctx,
                myLineChart,
                colorTable = {
                    ascent: '#585200',
                    climbmill: '#9a159b',
                    elliptical: '#ff9625',
                    treadmill: '#2f63cf',
                    bike_hybrid: '#de3700',
                    bike_upright: '#009829',
                    bike_recumbent: '#ff0093'
                };

            $translate(['UTILIZATION', 'TIME', 'DAY', 'MONTH']).then(function(translations) {
                scope.$watch('data', function(data) {
                    if (data) {
                        if (myLineChart) {
                            myLineChart.destroy();
                            element.find('canvas').remove();
                        }

                        element.append('<canvas></canvas>');

                        ctx = element.find('canvas')[0].getContext('2d');

                        if (scope.reportType === 'daily') {
                            drawDailyChart(data, translations);
                        } else if (scope.reportType === 'weekly') {
                            drawWeeklyChart(data, translations);
                        } else if (scope.reportType === 'monthly') {
                            drawMonthlyChart(data, translations);
                        }
                    }
                });
            });


            function drawDailyChart(data, translations) {
                myLineChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: data[0].data.map(function(d) {
                            return moment(d.x, 'HH:mm').set({
                                second: 0,
                                millisecond: 0
                            });
                        }),
                        datasets: data.map(function(set) {
                            var label = makeLabel(set.group),
                                borderColor;

                            if (!set.group.machine_type_code && !set.group.series) {
                                // Must by 'all data'
                                borderColor = '#2f63cf';
                            } else if (set.group.machine_type_code && !set.group.series) {
                                borderColor = colorTable[set.group.raw_machine_type_code];
                            }

                            if (!borderColor) {
                                // fallback
                                borderColor = randomColorGenerator();
                            }

                            return {
                                data: set.data.map(function(d) {
                                    return +d.y;
                                }),
                                borderWidth: 1,
                                fill: false,
                                backgroundColor: transparentize(borderColor),
                                borderColor: borderColor,
                                pointRadius: 0,
                                label: label.length > 1 ? label : $translate.instant('ALL_DATA'),
                                lineTension: 0
                            };
                        })
                    },
                    options: {
                        scales: {
                            xAxes: [{
                                type: 'time',
                                time: {
                                    displayFormats: {
                                        hour: 'h A'
                                    }
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: translations.TIME + ' (' + moment().tz(scope.timeZone).format('z') + ')'
                                }
                            }],
                            yAxes: [{
                                ticks: {
                                    min: 0,
                                    callback: function(tick) {
                                        return Math.round(tick * 100) + '%';
                                    }
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: translations.UTILIZATION
                                }
                            }]
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    var setLabel = data.datasets[tooltipItem.datasetIndex].label,
                                        value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                                    return setLabel + ': ' + Math.round(value * 100) + '%';
                                },
                                title: function(tooltipItem, data) {
                                    return moment(data.labels[tooltipItem[0].index]).format('LT');
                                }
                            }
                        }
                    }
                });
            }

            function drawWeeklyChart(data, translations) {
                myLineChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: data[0].data.map(function(d) {
                            return moment().day(d.x).set({
                                hour: 0,
                                minute: 0,
                                second: 0,
                                millisecond: 0
                            });
                        }),
                        datasets: data.map(function(set) {
                            var label = makeLabel(set.group),
                                borderColor;

                            if (!set.group.machine_type_code && !set.group.series) {
                                // Must by 'all data'
                                borderColor = '#2f63cf';
                            } else if (set.group.machine_type_code && !set.group.series) {
                                borderColor = colorTable[set.group.raw_machine_type_code];
                            }

                            if (!borderColor) {
                                // fallback
                                borderColor = randomColorGenerator();
                            }

                            return {
                                data: set.data.map(function(d) {
                                    return +d.y;
                                }),
                                borderWidth: 1,
                                fill: false,
                                backgroundColor: transparentize(borderColor),
                                borderColor: borderColor,
                                pointRadius: 0,
                                label: label.length > 1 ? label : $translate.instant('ALL_DATA'),
                                lineTension: 0
                            };
                        })
                    },
                    options: {
                        scales: {
                            xAxes: [{
                                type: 'time',
                                time: {
                                    unit: 'day',
                                    displayFormats: {
                                        day: 'dddd'
                                    }
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: translations.DAY
                                }
                            }],
                            yAxes: [{
                                ticks: {
                                    min: 0,
                                    callback: function(tick) {
                                        return Math.round(tick * 100) + '%';
                                    }
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: translations.UTILIZATION
                                }
                            }]
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    var setLabel = data.datasets[tooltipItem.datasetIndex].label,
                                        value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                                    return setLabel + ': ' + Math.round(value * 100) + '%';
                                },
                                title: function(tooltipItem, data) {
                                    return moment(data.labels[tooltipItem[0].index]).format('dddd');
                                }
                            }
                        }
                    }
                });
            }

            function drawMonthlyChart(data, translations) {
                myLineChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: data[0].data.map(function(d) {
                            return moment().month(+d.x).set({
                                date: 1, // not zero-indexed
                                hour: 0,
                                minute: 0,
                                second: 0,
                                millisecond: 0
                            });
                        }),
                        datasets: data.map(function(set) {
                            var label = makeLabel(set.group),
                                borderColor;

                            if (!set.group.machine_type_code && !set.group.series) {
                                // Must by 'all data'
                                borderColor = '#2f63cf';
                            } else if (set.group.machine_type_code && !set.group.series) {
                                borderColor = colorTable[set.group.raw_machine_type_code];
                            }

                            if (!borderColor) {
                                // fallback
                                borderColor = randomColorGenerator();
                            }

                            return {
                                data: set.data.map(function(d) {
                                    return +d.y;
                                }),
                                borderWidth: 1,
                                fill: false,
                                backgroundColor: transparentize(borderColor),
                                borderColor: borderColor,
                                pointRadius: 0,
                                label: label.length > 1 ? label : $translate.instant('ALL_DATA'),
                                lineTension: 0
                            };
                        })
                    },
                    options: {
                        scales: {
                            xAxes: [{
                                type: 'time',
                                time: {
                                    unit: 'month',
                                    displayFormats: {
                                        month: 'MMMM'
                                    }
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: translations.MONTH
                                }
                            }],
                            yAxes: [{
                                ticks: {
                                    min: 0,
                                    callback: function(tick) {
                                        return Math.round(tick * 100) + '%';
                                    }
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: translations.UTILIZATION
                                }
                            }]
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    var setLabel = data.datasets[tooltipItem.datasetIndex].label,
                                        value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                                    return setLabel + ': ' + Math.round(value * 100) + '%';
                                },
                                title: function(tooltipItem, data) {
                                    return moment(data.labels[tooltipItem[0].index]).format('MMMM');
                                }
                            }
                        }
                    }
                });
            }

            function makeLabel(group) {
                let labelParts = [];
                if (group.machine_type_code) {
                    labelParts.push($translate.instant($filter('uppercase')(group.machine_type_code)));
                }

                if (group.series) {
                    labelParts.push($filter('seriesName')(group.series));
                }

                return labelParts.join(' ');
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/chart.js